export default "__VITE_ASSET__28c7b7ef__"